import { Empty, Table } from 'antd';
import './table.css';

export default function CustomTable({
  loading,
  columns,
  dataSource,
  pagination,
  onChange,
  emptyText,
  classname
}) {
  return (
    <div className="w-full overflow-auto max-h-[80vh]">
      <Table
        footer={() => null}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        onChange={onChange}
        pagination={pagination}
        locale={{
          emptyText: () => (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={emptyText}
            />
          )
        }}
        className={`!rounded-lg hide-footer min-w-[900px] ${classname}`}
        style={{ border: '1px solid', borderColor: '#e5e7eb' }}
        components={{
          body: {
            cell: (props) => (
              <td {...props} className=" !py-3 !border-gray-200" />
            )
          },
          header: {
            cell: (props) => (
              <th
                {...props}
                className="!py-3 !m-0 !border-gray-200 !z-10 !sticky !-top-1"
              >
                {props.children}
              </th>
            )
          }
        }}
      />
    </div>
  );
}
